import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "newsletter-signup-2022" }
const _hoisted_2 = { class: "container newsletter-su-box" }
const _hoisted_3 = { class: "newsletter-su-column" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "newsletter-su-title" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("a", {
  href: "//www.patheos.com/subscribe/",
  class: "btn btn-sm btn-prime-2"
}, "see our full list of newsletters", -1)
const _hoisted_9 = { class: "newsletter-su-column" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h2", {
  class: "newsletter-su-title",
  style: {"margin-top":"0"}
}, "Thanks for signing up!", -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "form-group newsletter-su-form-group" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  for: "NewsletterSignup",
  class: "sr-only"
}, "Enter your email address", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-prime-2"
}, "sign me up", -1)
const _hoisted_17 = { class: "opt-out" }

import { ref, inject, onMounted, PropType } from 'vue';
import { useField, useForm } from 'vee-validate';
import { useLogger } from 'vue-logger-plugin';
import { NewslettersService } from '../../services/newsletters.service';
import { GTMService } from '../../services/gtm.service';
import useNewsletterSubmit from '../../composables/newsletter.composable';
import { LocationService } from '../../services/location.service';
import useValidators from '../../composables/validators.composable';

// inject our newsletter service

export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleSignup',
  props: {
    newsletterName: {
        type: String,
        default: ''
    },
    partner: {
        type: Boolean,
        default: false
    },
    sourceDesc: {
        type: String,
        default: ''
    },
    newsletters: {
        type: Array as PropType<string[]>,
        default: () => []
    },
    customMessage: {
        type: String,
        default: ''
    },
    pathUrl: {
        type: String,
        default: ''
    }
},
  setup(__props) {

const props = __props;

const newslettersService: NewslettersService | undefined = inject('NewslettersService');
// inject our locationservice
const locationService: LocationService | undefined = inject('LocationService');

const gtmService: GTMService | undefined = inject('GTMService');
const { newsletterSubmit } = useNewsletterSubmit(newslettersService, gtmService);

// Define Component Input Properties


const logger = useLogger();

// Component Locally Tracked Values
const submitted = ref(false);
const error = ref('');
const isCookieLawZone = ref(false);

// get validators
const { isRequired, isEmail } = useValidators();
// generate validation schema
const validationSchema = {
    email: (value: string) => isRequired(value) && isEmail(value),
    partners: () => true
};

// Form Configuration
const { handleSubmit, errors } = useForm({
    validationSchema,
    initialValues: {
        email: '',
        partners: !isCookieLawZone.value
    }
});

// Field Configurations
const { value: email } = useField('email');
const { value: partners } = useField('partners');

// Handle Form Submit
const submit = handleSubmit(async (form) => {
    logger.debug('submitting newsletter', form);

    // reset error message
    error.value = '';

    // submit to newsletter service
    const { message, success } = await newsletterSubmit(
        props.newsletters,
        form.email,
        props.sourceDesc,
        partners.value,
        props.pathUrl
    );

    if (success) {
        submitted.value = true;
    } else {
        submitted.value = false;
        error.value = message;
    }
});

onMounted(async () => {
    isCookieLawZone.value = (await locationService?.isCookieLawZone()) || false;
    logger.debug('Setting cookie zone law', isCookieLawZone.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (props.customMessage && props.customMessage.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", {
                class: "newsletter-su-title",
                innerHTML: decodeURIComponent(props.customMessage)
              }, null, 8, _hoisted_5)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createTextVNode("Sign up for the "),
                _createElementVNode("span", null, _toDisplayString(__props.newsletterName) + " Newsletter", 1)
              ]),
              _hoisted_8
            ]))
      ]),
      _createElementVNode("div", _hoisted_9, [
        (submitted.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("form", {
                class: "form-inline",
                onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_unref(submit) && _unref(submit)(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    id: "email",
                    placeholder: "Enter your email address",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(email) ? (email).value = $event : null))
                  }, null, 512), [
                    [_vModelText, _unref(email)]
                  ])
                ]),
                _hoisted_16
              ], 32),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(errors), (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "alert alert-danger add-top-margin",
                  role: "alert",
                  key: error
                }, _toDisplayString(error), 1))
              }), 128)),
              _withDirectives(_createElementVNode("div", _hoisted_17, " From time to time you will also receive Special Offers from our partners that help us make this content free for you. You can opt out of these offers at any time. ", 512), [
                [_vShow, !isCookieLawZone.value]
              ])
            ]))
      ])
    ])
  ]))
}
}

})